import React from 'react'
import Dropdown from './Dropdown'
import { Link } from 'react-router-dom'
import './Jstopbar.css'
import Whitelogo from './whitelogo.svg';


const linkStyle = {
  margin: "0rem 0px 0rem 0px",
  textDecoration: "none",
  color: 'white',
  fontSize: "12px",
};


export default function Jstopbar() {
  return (
    <div className='topcontainer'>
        <div className='top'>
            <div className='logocontainer'>
            <Link to = "/">
            <img src={Whitelogo} alt='codelearn' />
            </Link>
            </div>
            <Dropdown />
        </div>
    </div>
  )
}
